import { all, call, cancel, fork, put, take, takeEvery } from "redux-saga/effects";
import { types } from "./types";
import { FETCH_JOBS, FETCH_JOB } from "../../api/jobs";


function* GetJobs(action) {
  try {
    const { companyId, page, userId } = action.payload;
    const req = yield call(() =>
      FETCH_JOBS(companyId, page, userId)
    );
    const { jobs, currentPage, hasMore } = req.data;

    yield put({
      type: types.GET_ALL_JOBS_SUCCESS,
      jobs,
      currentPage,
      hasMore,
    });
  } catch (err) {
    yield put({ type: types.GET_ALL_JOBS_FAILED, error: err.message });
  }
}

function* GetJob(action) {
  try {
    const { payload } = action;
    const jobId = typeof payload === "object" && payload != null
      ? payload.jobId
      : payload;
    const filterUserId = typeof payload === "object" && payload != null
      ? payload.filterUserId
      : undefined;

    const { data } = yield call(() =>
      FETCH_JOB(jobId)
    );

    yield put({
      type: types.GET_A_JOB_SUCCESS,
      job: data,
      jobId,
      filterUserId,
    });
  } catch (err) {
    yield put({ type: types.GET_A_JOB_FAILED, error: err.message });
  }
}

// `takeEvery` runs every GET_A_JOB fetch concurrently with no ordering
// guarantee — two overlapping refetches for the same job (a leaked socket
// listener, a clap's own refresh racing a teammate's) can resolve out of
// order, and the reducer just does a blind replace, so a slow *older*
// response can land after a fresh one and revert the UI. Track the running
// task per jobId and cancel it when a newer request for the same job comes
// in, so only the latest response for a given job is ever applied.
function* watchGetJobRequest() {
  const runningByJobId = {};
  while (true) {
    const action = yield take(types.GET_A_JOB);
    const jobId = typeof action.payload === "object" && action.payload != null
      ? action.payload.jobId
      : action.payload;
    if (runningByJobId[jobId]) {
      yield cancel(runningByJobId[jobId]);
    }
    runningByJobId[jobId] = yield fork(GetJob, action);
  }
}

function* watchGetJobsRequest() {
  yield takeEvery(types.GET_ALL_JOBS, GetJobs);
  yield fork(watchGetJobRequest);
}

// root saga container
function* rootSaga() {
  yield all([fork(watchGetJobsRequest)]);
}

export default rootSaga;
